<template>
  <VueFileAgent :previewUrl="previewUrl" ref="vueFileAgent" :averageColor="true" :uploadHeaders="uploadHeaders"
                :multiple="multiple" :meta="meta" :deletable="deletable" :editable="editable" :linkable="linkable"
                :sortable="sortable" :readonly="readonly" :resumable="false" :disabled="disabled" :compact="compact"
                :accept="accept" :capture="capture" :maxSize="maxSize" :maxFiles="maxFiles" :theme="theme"
                @select="filesSelected($event)" @beforedelete="onBeforeDelete($event)"
                @upload="uploaded('upload', $event)" @upload:error="uploadEvent('upload:error', $event)"
                @upload:delete="uploadEvent('upload:delete', $event)"
                @upload:delete:error="uploadEvent('upload:delete:error', $event)"
                @upload:update="uploadEvent('upload:update', $event)"
                @upload:update:error="uploadEvent('upload:update:error', $event)" v-model="fileRecords"></VueFileAgent>
</template>

<script>
import {fileTypeList} from '../../utils/index'
import { getData } from "@/http/fetch.js";
import { conf } from "@/config";
export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      type: Array,
    },
    previewUrl: {
      type: String,
      default:conf.preHost
    },
    meta: {
      type: Boolean,
      default: false
    },
    auto: {
      type: Boolean,
      default: false
    },
    uploadUrl: {
      type: String,
      default: 'https://upload.qiniup.com/'
    },
    uploadHeaders: {
      type: Object
    },
    multiple: {
      type: Boolean,
      default: true
    },
    deletable: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: true
    },
    linkable: {
      type: Boolean,
      default: true
    },
    sortable: {
      type: Boolean,
      default: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    accept: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    capture: {
      type: Boolean,
      default: false
    },
    maxSize: {
      type: String,
      default: '100MB'
    },
    maxFiles: {
      type: Number,
      default: 20
    },
    theme: {
      type: String,
      default: 'list'
    }

  },
  data: function () {
    return {
      conf: conf,
      fileRecords: [],
    };
  },
  watch: {
    value: {
      deep: true,
      immediate:true,
      handler() {
        if (this.value && this.value.length > 0) {
          this.fileRecords = this.value.map((m) => {
            return {
              name: m.attachName,
              size: m.attachSize,
              url: m.attachUrl,
              type: m.attachType,
              classify: m.classify
            }
          })
        } else {
          this.fileRecords=[]
        }
      }
    }
  },

  methods: {
    uploaded(name, data) {



    },
    uploadEvent(eventName, data) {
      //console.log('UPLOAD EVENT ', eventName, data);
    },




    onBeforeDelete: function (fileRecord) {
      this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete'
      this.syncData()

    },
    syncData() {
      let list = [];
      if (this.fileRecords.length > 0) {
        list = this.fileRecords.map(m => {
          let classify = "other";
          let find = fileTypeList.find(f => f.type.some(s => s.contentType == m.type));
          if (find) {
            classify = find.value;
          }
          return {
            attachSize: m.size,
            attachUrl: typeof m.url == 'function' ? m.url() : m.url,
            attachType: m.type,
            attachName: typeof m.name == 'function' ? m.name() : m.name,
            classify
          }
        })
      }
      this.$emit('change', list)
    },


    deleteUploadedFile: function (fileRecord) {
      // Using the default uploader. You may use another uploader instead.
      // this.$refs.vueFileAgent.deleteUpload(this.uploadEndpoint, this.uploadHeaders, fileRecord);
    },
    filesSelected: async function (fileRecords) {
      try {
        let res = await getData("/file/getQiNiuAccessToken");
        const { domainUrl, accessToken } = res;

        this.$refs.vueFileAgent.upload(this.uploadUrl, this.uploadHeaders, fileRecords, function createFormData(file) {

          function uuid() {
            var s = [];
            var hexDigits = "0123456789abcdef";
            for (var i = 0; i < 36; i++) {
              s[i] = hexDigits.substr(Math.floor(Math.random() * 0x10), 1);
            }
            s[14] = "4"; // bits 12-15 of the time_hi_and_version field to 0010
            s[19] = hexDigits.substr((s[19] & 0x3) | 0x8, 1); // bits 6-7 of the clock_seq_hi_and_reserved to 01
            s[8] = s[13] = s[18] = s[23] = "-";

            var uuid = s.join("");
            return uuid;
          }
          let formData = new FormData();
          formData.append('token', accessToken);
          formData.append('key', (uuid() + '.' + file.ext()))
          formData.append('file', file.file);
          return formData;
        }).then(
          function (result) {
            // console.log('uploded: ', result);
            result.forEach(f => {
              f.fileRecord.url(domainUrl + f.data.key)
            })
            this.syncData()
          }.bind(this),
        );
      } catch (error) {
        this.$message({ type: "error", message: error });
      }

    },
  },

};
</script>
<style lang="less">
.el-form-item__content {
  .theme-list,.theme-grid {
    display: flow-root;
  }
  .file-input-wrapper{
    border-radius: 4px;
    border: 1px solid rgb(220, 223, 230) !important;
  }
}
</style>
